import { gql, useQuery } from "@apollo/client";
import {
  AlertOverviewQueryQuery,
  AlertOverviewQueryQueryVariables,
} from "../../../../schemaTypes";

export const alertOverviewQuery = gql`
  query AlertOverviewQuery($duration: String) {
    alertOverview(duration: $duration) {
      totalPushNotifications
      totalSubscribedUsers
      totalAlerts
    }
  }
`;

export function useAlertOverview(duration?: string) {
  const { data, loading, error, refetch } = useQuery<
    AlertOverviewQueryQuery,
    AlertOverviewQueryQueryVariables
  >(
    alertOverviewQuery,
    {
      variables: {
        duration: duration?.trim() || undefined,
      },
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    summary: data?.alertOverview,
    loading,
    error,
    refetch,
  };
}
